import { useAuth0 } from "@auth0/auth0-react";
import { createFileRoute } from "@tanstack/react-router";

type LoginSearch = {
  redirect: string;
  organization?: string; // The organization ID from Auth0 - if the user is sent to the login page with search params it is an invitation and this field will be populated with the ID.
};

export const Route = createFileRoute("/login")({
  component: Login,
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    return {
      redirect: (search.redirect as string) || "",
      organization: (search.organization as string) || ""
    };
  },
  loaderDeps: ({ search: { organization } }) => ({
    organization
  })
});

function Login() {
  const { redirect: searchRedirect } = Route.useSearch();

  const { loginWithRedirect } = useAuth0();

  loginWithRedirect({
    appState: { returnTo: searchRedirect },
    authorizationParams: {
      redirect_uri: `${window.location.origin}`
    }
  });
}
